module.exports = __webpack_public_path__ + "vue-app/img/big-1.ffef9a11.jpg";